//Fecha
import { format } from 'date-fns';
import es from 'date-fns/locale/es';

// Función encargada de devolver una fecha 7 días posterior a la recibida, como string y con la forma mm/dd/yyyy
export const getNextWeek = str => {
  // Fecha inicial
  const auxDate = new Date(str);
  // Máxima fecha que puede ser elegida
  const endDate = new Date(auxDate.setDate(auxDate.getDate() + 7));
  // La formateamos como MM/DD/YYYY
  const endDateString = [
    (endDate.getMonth() + 1).toString().padStart(2, '0'),
    endDate.getDate().toString().padStart(2, '0'),
    endDate.getFullYear().toString().padStart(2, '0'),
  ].join('/');
  return endDateString;
};

//funcion para devolver x camntidad de dias mas q el dia enviado por parametro, pero si el resultado va a ser mayor al dia actual se envia el actual
export const getNextWeekMaxToday = (str, numberDaysbetweens) => {
  // Fecha inicial
  const auxDate = new Date(str);
  // Máxima fecha que puede ser elegida
  const endDate = new Date(
    auxDate.setDate(auxDate.getDate() + numberDaysbetweens)
  );
  // La formateamos como MM/DD/YYYY
  const endDateString = [
    (endDate.getMonth() + 1).toString().padStart(2, '0'),
    endDate.getDate().toString().padStart(2, '0'),
    endDate.getFullYear().toString().padStart(2, '0'),
  ].join('/');
  if (endDate >= new Date()) {
    return new Date();
  } else {
    return endDateString;
  }
};

// Función encargada de devolver una fecha  x cantidad de días posterior a la recibida, como string y con la forma mm/dd/yyyy
export const getControlDay = (str, numberOfDays) => {
  // Fecha inicial
  const auxDate = new Date(str);
  // Máxima fecha que puede ser elegida
  const endDate = new Date(
    auxDate.setDate(auxDate.getDate() - numberOfDays + 1)
  );
  // La formateamos como MM/DD/YYYY
  const endDateString = [
    (endDate.getMonth() + 1).toString().padStart(2, '0'),
    endDate.getDate().toString().padStart(2, '0'),
    endDate.getFullYear().toString().padStart(2, '0'),
  ].join('/');
  return endDateString;
};

// Función encargada de devolver una fecha 1 día posterior a la recibida, como string y con la forma mm/dd/yyyy
export const getTomorrowDate = str => {
  // Fecha inicial
  const auxDate = new Date(str);
  // Máxima fecha que puede ser elegida
  const endDate = new Date(auxDate.setDate(auxDate.getDate() + 1));
  // La formateamos como MM/DD/YYYY
  const endDateString = [
    (endDate.getMonth() + 1).toString().padStart(2, '0'),
    endDate.getDate().toString().padStart(2, '0'),
    endDate.getFullYear().toString().padStart(2, '0'),
  ].join('/');
  return endDateString;
};

//Función encargada de convertir una fecha YYYY-MM.DD en DD/MM/YYYY
export const formatDateStrDashToSlash = date => {
  //2022-02-01
  const dateArray = date.split('-');
  const year = dateArray[0];
  const month = dateArray[1];
  const day = dateArray[2];
  return `${day}/${month}/${year}`;
};

// * Función encargada de convertir una fecha YYYY-MM.DD en MM/dd/yyyy
export const formatDateStrDashToSlashReverse = date => {
  //MM/dd/yyyy
  const dateArray = date?.split('-');
  const year = dateArray[0];
  const month = dateArray[1];
  const day = dateArray[2];
  return `${month}/${day}/${year}`;
};

// Convierte una fecha YYYY-MM-DD a Date en zona local sin depender del parser del navegador.
export const parseDateStrDashToLocalDate = date => {
  if (!date || typeof date !== 'string') return null;

  const [yearStr, monthStr, dayStr] = date.split('-');
  const year = Number(yearStr);
  const month = Number(monthStr);
  const day = Number(dayStr);

  if (![year, month, day].every(Number.isInteger)) return null;

  const parsedDate = new Date(year, month - 1, day, 12, 0, 0, 0);

  if (
    parsedDate.getFullYear() !== year ||
    parsedDate.getMonth() !== month - 1 ||
    parsedDate.getDate() !== day
  ) {
    return null;
  }

  return parsedDate;
};

export const formatDateObjToSlash = dateObj => {
  return `${dateObj.getDate()}/${dateObj.getMonth() + 1
    }/${dateObj.getFullYear()}`;
};

// Recibo una fecha del formato 2022-05-01 y lo retorno un objeto Date con el último día de ese mes.
export const getLastDayOfMonthFromStr = str => {
  // Como obtengo el primer día del mes y el endpoint de eventos me devolvería solo los eventos de ese día, quiero el mes completo.
  const dateObj = new Date(str);
  const userTimezoneOffset = dateObj.getTimezoneOffset() * 60000;
  const newDate = new Date(dateObj.getTime() - userTimezoneOffset);
  return new Date(newDate.getFullYear(), newDate.getMonth() + 2, 0);
};

export const truncateWithEllipsis = (s, maxLength = 15) => {
  if (s === null) {
    return '';
  }
  if (s.length > maxLength) {
    return s.substring(0, maxLength) + '...';
  }
  return s;
};


// Función encargada de convertir un string a un número con el formato esperado.
// Usar "," como separadores de miles.
// Usar "." como separador decimal.
// Usar 2 posiciones decimales.
export const toFormattedNumber = (str, unit = '') => {
  if (typeof str === 'object') return '-';
  if (str === 0) {
    return unit === '$'
      ? `${unit} 0`
      : `0 ${unit}`;
  }
  if (!str) return '-';
  const usNumber = Number(str).toLocaleString('en-US', {
    maximumFractionDigits: 2,
  });
  return unit === '$'
    ? `${unit} ${usNumber}`
    : `${usNumber} ${unit}`;
};


export const toFormattedNumberNoUnit = (str) => {
  if (str === 0) {
    return ''
  }
  // Validar que la cadena solo contenga números o punto decimal
  // const regex = /^[0-9]+(\.[0-9]+)?$/;
  // if (!regex.test(str)) {
  //   return '';  // Si no es un número válido, retorna '-'.
  // }
  else {
    if (!str) return '-';
    // Verificar si la cadena contiene un punto decimal
    if (str.includes('.')) {
      // Dividir el número en parte entera y parte decimal
      var partes = str.split(".");
      var parteEntera = partes[0];
      var parteDecimal = partes[1] || "";
      // Agregar comas para separar la parte entera en grupos de tres dígitos
      var parteEnteraFormateada = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // Combinar la parte entera formateada con la parte decimal
      var numeroFormateado = parteEnteraFormateada + "." + parteDecimal;
      return numeroFormateado;
    }
    else {
      // Si no hay punto decimal, simplemente agregar comas de mil
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};

// Función encargada de mezclar colores.
// Conservo los primeros tres dígitos de un color, los últimos tres del otro y los invierto.
// generateColor('#123456', '#789ABC') // '#ABC123'
export const mixColors = (color1, color2) => {
  if (!color2) {
    return color1;
  }

  return '#' + color2.slice(4) + color1.slice(1, 4);
};

export const getFormattedNumber = (x) => {
  const abs = Math.abs(x);
  let value;
  if (abs >= 1_000_000_000_000) {
    value = x / 1_000_000_000_000; // PWh
  } else if (abs >= 1_000_000_000) {
    value = x / 1_000_000_000;     // TWh
  } else if (abs >= 1_000_000) {
    value = x / 1_000_000;         // GWh
  } else if (abs >= 1_000) {
    value = x / 1_000;             // MWh
  } else {
    value = x;                     // kWh
  }

  return toFormattedNumber(value); // Asegúrate de que esta función dé 2 decimales
};

export const getUnit = (x) => {
  const abs = Math.abs(x);
  if (abs >= 1_000_000_000_000) return 'P'; // Petawatt-hora
  if (abs >= 1_000_000_000) return 'T';     // Terawatt-hora
  if (abs >= 1_000_000) return 'G';         // Gigawatt-hora
  if (abs >= 1_000) return 'M';             // Megawatt-hora
  return 'k';                               // Kilowatt-hora
};

export const getUnitWatts = (x) => {
  const abs = Math.abs(x);
  if (abs >= 1_000_000_000_000) return 'P'; // Peta
  if (abs >= 1_000_000_000) return 'T';     // Tera
  if (abs >= 1_000_000) return 'G';         // Giga
  if (abs >= 1_000) return 'k';             // Kilo
  return ''; // No unidad para valores < 1000
};

//funcion para optimizar condicion si existe valor devolver el mismo valor si no existe devuelve "-"
export const returnEmpty = value => {
  if (value) return value;
  return '-';
};

//function q transfomra la primera letra en mayuscula
export const capitalizeFirstLetter = str => {
  if (!str) return str; // Manejo de casos en los que la cadena sea null, undefined o vacía
  const capitalized = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  // if (capitalized.length > 14) {
  //   return capitalized.substring(0, 19);
  // }
  return capitalized;
};

//funcion q devuelve en forma de string el nombre de el mes formato  "marzo 2023"    o el año  "este año 2023" //funcion para optimizar condicion si existe valor devolver el mismo valor si no existe devuelve "-"
export const returnDateString = option => {
  if (option === 'm') {
    return `${format(new Date(), 'MMMM yyyy', { locale: es })}`;
  }
  if (option === 'y') {
    return `este año ${format(new Date(), 'yyyy', { locale: es })}`;
  }
  if (option === 'h') {
    return `Historico`;
  }
};

//retorna html linea azul q divide bloques de franjas.
export const blueBar = () => {
  return (
    <div
      style={{
        backgroundColor: '#2586bc69',
        height: '1px ',
        width: ' 100 %',
        margin: '10px 0 10px 0',
      }}
    ></div>
  );
};

export const isValidEmail = str => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(str);
};

const NF = (locale = "en-US", maxFrac = 2) =>
  new Intl.NumberFormat(locale, { maximumFractionDigits: maxFrac });

function normalizeUnit(raw) {
  const u = (raw || "").trim();
  const map = {
    "w": "W", "kw": "kW", "mw": "MW", "gw": "GW",
    "var": "VAr", "kvar": "kVAr", "mvar": "MVAr", "gvar": "GVAr",
    "wh": "Wh", "kwh": "kWh", "mwh": "MWh", "gwh": "GWh",
    "v": "V", "kv": "kV",
    "a": "A", "ka": "kA",
    "°c": "°C", "c°": "°C"
  };
  const key = u.toLowerCase();
  return map[key] || u;
}

const UNITS = {
  POWER_ACTIVE: { order: ["W", "kW", "MW", "GW"], factor: { W: 1, kW: 1e3, MW: 1e6, GW: 1e9 } },
  POWER_REACTIVE: { order: ["VAr", "kVAr", "MVAr", "GVAr"], factor: { VAr: 1, kVAr: 1e3, MVAr: 1e6, GVAr: 1e9 } },
  ENERGY: { order: ["Wh", "kWh", "MWh", "GWh"], factor: { Wh: 1, kWh: 1e3, MWh: 1e6, GWh: 1e9 } },
  VOLTAGE: { order: ["V", "kV"], factor: { V: 1, kV: 1e3 } },
  CURRENT: { order: ["A", "kA"], factor: { A: 1, kA: 1e3 } },
  TEMP: { order: ["°C"], factor: { "°C": 1 } },
  NONE: { order: [""], factor: { "": 1 } }
};

function detectFamily(unit) {
  if (["W","kW","MW","GW"].includes(unit)) return "POWER_ACTIVE";
  if (["VAr","kVAr","MVAr","GVAr"].includes(unit)) return "POWER_REACTIVE";
  if (["Wh","kWh","MWh","GWh"].includes(unit)) return "ENERGY";
  if (["V","kV"].includes(unit)) return "VOLTAGE";
  if (["A","kA"].includes(unit)) return "CURRENT";
  if (["°C"].includes(unit)) return "TEMP";
  if (unit === "") return "NONE";
  return null;
}

export function formatNumber(unit, value, opts = {}) {
  const locale = opts.locale || "en-US";
  const decimals = opts.decimals || 2;
  const u = normalizeUnit(unit);
  const family = detectFamily(u);
  if (!family) return NF(locale, decimals).format(value) + " " + u;
  const { order, factor } = UNITS[family];
  let baseVal = value * factor[u];
  let targetUnit = u;
  for (let i = 0; i < order.length; i++) {
    const nextUnit = order[i];
    if (baseVal < 1000 * factor[nextUnit]) {
      targetUnit = nextUnit;
      break;
    }
  }
  const scaled = baseVal / factor[targetUnit];
  return NF(locale, decimals).format(scaled) + " " + targetUnit;
}
